<table aria-label="parameterTable" class="table table-fixed">
  <thead style="background-color: white">
    <tr>
      <th scope="col"></th>
      <th scope="col" *ngFor="let title of titles; let i = index">
        <a class="link" (click)="openResult(i)">{{ title }}</a>
      </th>
    </tr>
  </thead>
  <tbody *ngFor="let item of compareList">
    <tr id="group">
      <th scope="row" style="color: #f49602">{{ item.group }}</th>
    </tr>
    <tr *ngFor="let dict of item.values">
      <th id="key">{{ dict.key }}</th>
      <th id="values" *ngFor="let value of dict.compareValues">
        {{ value }}
      </th>
    </tr>
  </tbody>
</table>
